module.exports = "<svg viewBox=\"0 0 18 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 24H1a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2zm-8-4c-4.187 0-7-2.813-7-7V1a1 1 0 0 1 2 0v12c0 3.084 1.916 5 5 5s5-1.916 5-5V1a1 1 0 0 1 2 0v12c0 4.187-2.813 7-7 7z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/shared/InlineEditor/images/underline.svg
// module id = NOHI
// module chunks = 89